<template>
  <div class="spellchecker-panel" :class="{'absolute': rightNavActiveTab}">
    <aha-multi-tabs
      :tabTitles="tabTitles"
      :postTitleComponent="postTitleComponent"
      closeable
      @onCloseButtonClicked="closePanel()"
    >
      <template #tab-0>
        <SpellcheckerPanelContent />
      </template>
    </aha-multi-tabs>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { markRaw } from 'vue'
import SpellcheckerPanelContent from '@/components-v2/presentation-editor/editor-header/quality-control/SpellcheckerPanelContent.vue'
import SpellcheckerPanelPostTitle from '@/components-v2/presentation-editor/editor-header/quality-control/SpellcheckerPanelPostTitle.vue'

export default {
  components: {
    SpellcheckerPanelContent,
  },

  computed: {
    ...mapGetters('rightNav', ['rightNavActiveTab']),

    tabTitles() {
      return ['Potential Issues']
    },
    postTitleComponent() {
      return [markRaw(SpellcheckerPanelPostTitle)]
    },
  },

  methods: {
    ...mapActions('rightNav', ['setRightNavActiveTabAction']),

    closePanel() {
      this.setRightNavActiveTabAction('')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.spellchecker-panel {
  @apply h-full;
  right: $right-nav-width;

  .multi-tabs {
    @apply rounded-lg my-3 mr-2 border border-base-30 overflow-hidden bg-base-0 relative;
    width: 384px;
    height: calc(100% - 1.5rem);
    box-shadow: 0px 10px 38px 0px #525F7F08;
    transform: scale(1); // to make settings-header fixed and follow this parent
  }

  &::v-deep {
    .multi-tabs__content {
      @apply h-full;
    }
    .multi-tabs__header {
      @apply w-full fixed top-0 z-10 border-b border-base-30 bg-base-0;
      @apply p-4 font-bold text-base text-secondary-100 justify-between;
      height: $right-panel-header-height;
      .aha-tab-title {
        @apply flex items-center;
      }
    }
  }
}
</style>
